import React from "react";
//import './index.css'
import { render } from "react-dom";
import Routes from "../resources/static/react/route";
import store from "../resources/static/react/reducers";
import { Provider } from 'react-redux';
import HeaderSearch from "../resources/static/react/Component/HeaderSearch";





class App extends React.Component {

  render() {
    return (
            <React.Fragment>
                <Routes />
            </React.Fragment>
        )
  }
}

class AppSearch extends React.Component {

  render() {
    return (
        <React.Fragment>
            <HeaderSearch />
        </React.Fragment>
        )
  }
}
render(
  <Provider store={store} ><AppSearch /></Provider>,
  document.getElementById('react-search')
)
if(document.getElementById('react')) {
    render(
      <Provider store={store} ><App /></Provider>,
      document.getElementById('react')
    )
}


